package com.essntl.features.service.ui.addeditservice

import androidx.compose.runtime.MutableState
import androidx.compose.runtime.mutableStateOf
import com.essntl.core.utils.viewmodel.State
import com.essntl.features.area.domain.model.AreaModel
import com.essntl.features.category.domain.model.CategoryModel
import com.essntl.features.file.ui.FileState
import com.essntl.features.profile.domain.model.ProfileModel
import com.essntl.features.service.domain.model.service.ServiceModel
import com.essntl.features.service.domain.model.supplierservice.SupplierServiceModel
import com.essntl.features.supplier.domain.model.SupplierModel
import com.essntl.features.tag.domain.model.TagModel

data class AddEditServiceState(
    val imageState: FileState = FileState(),
    val addEditService: State<ServiceModel> = State(),
    val getAllSuppliersService: State<List<SupplierServiceModel>> = State(),
    val addSupplierService: State<SupplierServiceModel> = State(),
    val deleteSupplierService: State<Unit> = State(),
    val getSupplier: State<SupplierModel> = State(),
    val service: MutableState<ServiceModel> = mutableStateOf(ServiceModel.empty),
    val getService: State<ServiceModel> = State(),
    val getAllTag: State<List<TagModel>> = State(),
    val getAllCategory: State<List<CategoryModel>> = State(),
    val getAllArea: State<List<AreaModel>> = State(),
    val getProfile: State<ProfileModel> = State(),
    val thumbnailIndex: Int = 0,
    val isEditMode: Boolean = false,  // Renamed from isEditEnabled
    val hasChanges: Boolean = false,  // Whether there are unsaved changes
    val addTagLoadingMap: Set<String> = emptySet(),
    val rewriteWithAI: State<String> = State(),
)
